import { render } from "./ScoreboardMetricModal.vue?vue&type=template&id=e683df94&scoped=true&ts=true"
import script from "./ScoreboardMetricModal.vue?vue&type=script&lang=ts"
export * from "./ScoreboardMetricModal.vue?vue&type=script&lang=ts"

import "./ScoreboardMetricModal.vue?vue&type=style&index=0&id=e683df94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e683df94"]])

export default __exports__